<template>
	<details class="v-accordion" :class="accordionClass" :id="id" :style="[elStyles]" v-on="$listeners">
		<summary class="v-accordion__summary" @click.prevent="!disableTitleToggle && toggle()">
			<slot name="title" :toggle="toggle"/>
		</summary>
		<div data-content class="v-accordion__content" :style="[contentStyles]">
			<slot name="default" :toggle="toggle"/>
		</div>
	</details>
</template>
<script>
export default {
	data() {
		return {
			animation: null,
			isClosing: false,
			isOpening: false,
			isOpen: false
		};
	},

	computed: {
		accordionClass() {
			return {
				"v-accordion--closed": !this.isOpen,
				"v-accordion--closing": this.isClosing,
				"v-accordion--open": this.isOpen,
				"v-accordion--opening": this.isOpening
			};
		},
		elStyles() {
			return {
				overflow: "hidden"
			};
		},
		contentStyles() {
			return {
				willChange: "height"
			};
		},
		elements() {
			return {
				summary: this.$el.querySelector("summary"),
				content: this.$el.querySelector("[data-content]")
			};
		}
	},

	props: {
		show: {
			required: false,
			type: Boolean,
			default: false
		},
		duration: {
			required: false,
			type: Number
		},
		easing: {
			required: false,
			type: String,
			default() {
				return "cubic-bezier(0.25, 0.1, 0.25, 1)";
			}
		},
		id: {
			required: false,
			type: String,
			default() {
				return "v-accordion--" + this._uid;
			}
		},
		disableTitleToggle: {
			required: false,
			type: Boolean,
			default() {
				return false;
			}
		}
	},

	methods: {
		toggle() {
			if (this.isClosing || !this.$el.open) {
				this.open();
			} else if (this.isOpening || this.$el.open) {
				this.close();
			}
		},
		heights() {
			return {
				content: this.elements.content.offsetHeight
			};
		},
		open() {
			this.$el.open = true;
			window.requestAnimationFrame(() => this.expand());
		},
		expand() {
			this.event("accordionOpening");
			this.isOpening = true;
			this.animation?.cancel();
			this.animate(this.heights().content);
			this.animation.onfinish = () => this.onAnimationFinish();
			this.animation.oncancel = () => this.isOpening = false;
		},
		close() {
			this.event("accordionClosing");
			this.isClosing = true;
			this.animation?.cancel();
			this.animate(0);
			this.animation.onfinish = () => this.onAnimationFinish(false);
			this.animation.oncancel = () => this.isClosing = false;
		},
		animate(endHeight) {
			const startHeight = endHeight > 0 ? 0 : this.heights().content;
			this.animation = this.elements.content.animate({
				height: [
					`${startHeight}px`,
					`${endHeight}px`
				]
			}, {
				duration: this.duration || this.autoDuration(Math.max(this.heights().content, endHeight)),
				easing: this.easing
			});
		},
		onAnimationFinish(open = true) {
			this.event(open ? "accordionOpened" : "accordionClosed");
			this.$el.open = open;
			this.animation = null;
			this.isClosing = false;
			this.isOpening = false;
			this.isOpen = open;
		},
		event(eventName) {
			this.$emit(eventName, this.id);
			this.$parent[eventName]?.(this.id);
		},
		autoDuration(height) {
			const constant = height / 36;
			return Math.round((4 + 15 * constant ** 0.25 + constant / 5) * 10);
		}
	},

	mounted() {
		if (this.show) {
			this.open();
		}
	}
};
</script>
